// src/components/PracticeOverviews.js
import React from "react";

const PRACTICE_COLOR = {
  "Data & AI":       "#0369a1",
  "Cloud & Digital": "#15803d",
  "TL&M":            "#7c3aed",
};

function DocLink({ url, label, icon }) {
  if (!url) return null;
  return (
    <a href={url} className="po-doc-link" target="_blank" rel="noopener noreferrer">
      <span className="po-doc-link-icon">{icon}</span> {label}
    </a>
  );
}

export function PracticeOverviews({ overviews, loading }) {
  if (loading) return <div className="dash-loading"><span>Loading...</span></div>;
  if (!overviews || overviews.length === 0) return null;

  return (
    <div className="po-page">
      <div className="po-intro">
        <div className="po-intro-eyebrow">
          <span className="po-intro-line"></span>
          <span className="po-intro-eyebrow-text">NIIT Enterprise Tech Learning Solutions</span>
        </div>
        <div className="po-intro-title">Practice Overview</div>
      </div>

      <div className="po-cards">
        {overviews.map((o) => {
          const color = PRACTICE_COLOR[o.practice] || "#718096";
          return (
            <div className="po-card" key={o.id}>
              <div className="po-card-stripe" style={{ background: color }} />
              <div className="po-card-body">
                <div className="po-card-header">
                  <div className="po-card-dot" style={{ background: color }} />
                  <div className="po-card-name" style={{ color }}>{o.practice}</div>
                </div>
                <div className="po-doc-list">
                  <DocLink url={o.coverEmail}         label="Cover Email"          icon="✉️" />
                  <DocLink url={o.approachNote}       label="Product Note"         icon="📄" />
                  <DocLink url={o.successStory}       label="Success Story"        icon="⭐" />
                  <DocLink url={o.discoveryQuestions} label="Discovery Questions"  icon="🔍" />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
